export default {
    loading: false,
    status: false,
}